import WorldMap from './WorldMap';

export default function AboutSection() {
  return (
    <section id="about" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        {/* Header row */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="text-[#d4571a] text-xs font-semibold tracking-widest uppercase mb-3">
              NRG Trading
            </p>
            <h2 className="text-[#0c1f38] text-4xl font-bold leading-tight">
              A Global Energy<br />Company
            </h2>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed max-w-md md:text-right">
            NRG Trading operates across key strategic hubs worldwide, connecting energy markets and delivering value internationally.
          </p>
        </div>

        {/* Full-width map */}
        <WorldMap />
      </div>
    </section>
  );
}
